import React, { createContext, useState } from "react";

type CSVValueProps = {
  [x: string]: string | number | unknown[] | boolean | undefined;
};

interface UploadCentreContextProps {
  uploadedDataCSV: CSVValueProps[];
  setUploadedDataCSV: React.Dispatch<React.SetStateAction<CSVValueProps[]>>;
  uploadedDataError: string[];
  setUploadedDataError: React.Dispatch<React.SetStateAction<string[]>>;
  csvName: string;
  setCsvName: React.Dispatch<React.SetStateAction<string>>;
}

const UploadCentreContext = createContext<UploadCentreContextProps>({} as UploadCentreContextProps);

interface IUploadCentreProviderProps {
  children: React.ReactChild;
}

const UploadCentreProvider = ({ children }: IUploadCentreProviderProps) => {
  const [uploadedDataCSV, setUploadedDataCSV] = useState<CSVValueProps[]>([]);
  const [uploadedDataError, setUploadedDataError] = useState<string[]>([]);
  const [csvName, setCsvName] = useState<string>("");

  return (
    <UploadCentreContext.Provider
      value={{
        uploadedDataCSV,
        setUploadedDataCSV,
        uploadedDataError,
        setUploadedDataError,
        csvName,
        setCsvName,
      }}
    >
      {children}
    </UploadCentreContext.Provider>
  );
};

export { UploadCentreContext, UploadCentreProvider };
